import React from 'react';
import {
  useHeadlessConsentUI, 
  useConsentManager 
} from '@c15t/react';
import './style.scss';

function ConsentUI() {
  const { 
    activeUI, 
    saveCustomPreferences, 
    openDialog, 
    closeUI 
  } = useHeadlessConsentUI();

  const { selectedConsents, setSelectedConsent } = useConsentManager();

    const CUSTOM_CATEGORIES = [
        {
            id: 'necessary',
            label: 'Niezbędne pliki cookie',
            description: 'Wymagane do prawidłowego funkcjonowania strony i bezpieczeństwa. Nie można ich wyłączyć.',
            required: true,
        },
        {
            id: 'analytics',
            label: 'Analityczne pliki cookie',
            description: 'Pomagają nam zrozumieć, w jaki sposób odwiedzający korzystają ze strony (np. Google Analytics).',
            required: false,
        },
        {
            id: 'marketing',
            label: 'Marketing i reklama',
            description: 'Używane do śledzenia odwiedzających i wyświetlania dopasowanych reklam (np. Meta Pixel).',
            required: false,
        },
        {
            id: 'functional',
            label: 'Funkcjonalne pliki cookie',
            description: 'Umożliwiają zapamiętanie wybranych przez Ciebie ustawień (np. język strony, motyw).',
            required: false,
        },
    ];

    const handleAcceptAll = () => {
        CUSTOM_CATEGORIES.forEach(cat => setSelectedConsent(cat.id, true));
        saveCustomPreferences();
        closeUI();
    };

    const handleRejectOptional = () => {
        CUSTOM_CATEGORIES.forEach(cat => {
        if (!cat.required) {
            setSelectedConsent(cat.id, false);
        }
        });
        saveCustomPreferences();
        closeUI();
    };

    const handleSavePreferences = () => {
        saveCustomPreferences();
        closeUI();
    };

  if (!activeUI) return null;

  return (
    <>
      {activeUI === 'banner' && (
        <div className="c15t-banner-wrapper">
          <div className="c15t-banner-header">
            <h3>Dbamy o Twoją prywatność</h3>
          </div>
          <p className="c15t-banner-text">
            Używamy plików cookie i podobnych technologii do analizy ruchu, personalizacji treści oraz prawidłowego działania strony.
          </p>
          <div className="c15t-button-group">
            <button 
              className="c15t-btn c15t-btn-primary" 
              onClick={handleAcceptAll}
            >
              Zaakceptuj wszystkie
            </button>
            <button 
              className="c15t-btn c15t-btn-secondary" 
              onClick={handleRejectOptional}
            >
              Odrzuć opcjonalne
            </button>
            <button 
              className="c15t-btn c15t-btn-outline" 
              onClick={() => openDialog()}
            >
              Ustawienia
            </button>
          </div>
        </div>
      )}

      {activeUI === 'dialog' && (
        <div className="c15t-modal-overlay">
          <div className="c15t-modal-content">
            <div className="c15t-modal-header">
              <div>
                <h2>Centrum Preferencji Prywatności</h2>
                <p>Zarządzaj swoimi zgodami dotyczącymi plików cookie</p>
              </div>
              <button className="c15t-close-btn" onClick={() => closeUI()}>✕</button>
            </div>

            <div className="c15t-modal-body">
              {CUSTOM_CATEGORIES.map((category) => (
                <div key={category.id} className="c15t-category-card">
                  <div className="c15t-category-info">
                    <div className="c15t-category-title">
                      <h4>{category.label}</h4>
                      {category.required && <span className="c15t-badge">Niezbędne</span>}
                    </div>
                    <p>{category.description}</p>
                  </div>
                  <label className="c15t-toggle">
                    <input
                      type="checkbox"
                      disabled={category.required}
                      checked={category.required || !!selectedConsents[category.id]}
                      onChange={(e) => setSelectedConsent(category.id, e.target.checked)}
                    />
                    <span className="c15t-slider"></span>
                  </label>
                </div>
              ))}
            </div>

            <div className="c15t-modal-footer">
              <button 
                className="c15t-btn c15t-btn-secondary" 
                onClick={handleRejectOptional}
              >
                Odrzuć opcjonalne
              </button>
              <button 
                className="c15t-btn c15t-btn-outline" 
                onClick={handleSavePreferences}
              >
                Zapisz wybrane
              </button>
              <button 
                className="c15t-btn c15t-btn-primary" 
                onClick={handleAcceptAll}
              >
                Zaakceptuj wszystkie
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default function CookieConsent() {
  return (
    <ConsentUI />
  );
}